/**
 * Required Module
 */
import axios, { get } from 'axios';
import { ENDPOINT } from '../config/endpoints';

/**
 * Function for fetching custom
 * seo details
 * @param {number} storeId
 * @return {object}
 */
async function getSEODetails(storeId) {
  try {
    const response = await get(ENDPOINT.SEO.getCustomSeoDetails(storeId), {
      headers: {
        app_os: 'cfe',
      },
    });
    return { error: null, data: response.data };
  } catch (error) {
    return { error };
  }
}

async function getCachedHTML(url) {
  try {
    const response = await get(ENDPOINT.SEO.getHTML());
    return { error: null, data: response.data };
  } catch (error) {
    return { error };
  }
}

async function saveHTMLData(body, auth_token) {
  try {
    const response = await axios.post(ENDPOINT.SEO.saveHTML, body, {
      headers: { auth_token },
    });
    return { error: null, data: response.data };
  } catch (error) {
    return { error };
  }
}

async function generateOneTimeTokenSEO() {
  try {
    const response = await get(ENDPOINT.SEO.generateTokenForSEO);
    return { error: null, data: response.data };
  } catch (error) {
    return { error };
  }
}

/**
 * Add Exported Function here
 */
export { getSEODetails, getCachedHTML, generateOneTimeTokenSEO, saveHTMLData };
